import React from 'react';
import {useSelectorWithRefresh} from '@/store/kysely_module';
import {useModule} from '@/hooks/useModule';
import {WavesurferWithHook} from '@/components/wavesurfer_with_hook';
import {DBObjects} from '@/store/store_types';

type Props = {
    fileInfo: DBObjects['File'];
    style?: React.CSSProperties;
    onTimestampAction?: (timestamp: string, action: 'comment') => void;
};

export const FileWaveform = ({ fileInfo, style, onTimestampAction }: Props) => {
    const audioPlayerModule = useModule('AudioPlayer');

    // Get waveform data
    const [waveformAndDuration] = useSelectorWithRefresh(
        'getFileWaveformAndDuration',
        {file_id: fileInfo.id},
        null,
        {workspace_id: fileInfo.workspace_id}
    );

    // Audio playback status
    const playbackStatus = audioPlayerModule.useAudioPlaybackStatus();
    const isCurrentFile = playbackStatus?.fileInfo?.id === fileInfo.id;
    const isPlaying = isCurrentFile && playbackStatus?.isPlaying;

    if (!waveformAndDuration?.duration || !waveformAndDuration?.waveform_data) {
        return null;
    }

    const defaultStyle: React.CSSProperties = {
        // border: '1px solid var(--mantine-color-gray-3)',
        boxShadow: '2px 2px 8px 1px black',
        borderRadius: '8px',
        padding: '10px',
        ...style
    };

    return (
        <div style={defaultStyle}>
            <WavesurferWithHook
                height={60}
                isCurrentFile={isCurrentFile || false}
                isPlaying={isPlaying || false}
                onTimestampAction={onTimestampAction || (() => {})}
                duration={waveformAndDuration.duration}
                peaks={waveformAndDuration.waveform_data}
                regions={[]}
                onSeek={(seconds => {
                    audioPlayerModule.playAndSeek(fileInfo, seconds);
                })}
            />
        </div>
    );
};
